<div class="admin-navigation-container">
  <p-menubar [model]="menuItems"></p-menubar>
  <div class="admin-content">
    <router-outlet></router-outlet>
  </div>
</div>
